import { getParam, isToufangWebView, setStorage, getStorage } from './tools'
import Cookies from 'js-cookie';
import {AD_ID_COOKIES_KEY, IS_TOUFANG_STORE_KEY, LOVERFLIX_FROM_STORE_KEY, USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY, LOVERFLIX_USER_ID_COOKIES_KEY, LOVERFLIX_USER_TOKEN_COOKIES_KEY} from './constant'

// 图片地址
export const IMG_BASE_URL = 'https://static.novelfreedom.com/';
export const LOCAL_IMG_URL = IMG_BASE_URL + 'paynovel/h5-pay-asia/';
// https://static.novelfreedom.com/paynovel/h5-pay-asia/


// 获取版本号
export const getVersion = () => {
    return '1.1.2'
}

// 获取fb pixel id
export const getFbPixelId = () => {
    return APP_CONFIG[getAppIdConfig()]?.fbPixleId || APP_CONFIG['default'].fbPixleId
}

export const getTtPixelId = () => {
    return APP_CONFIG[getAppIdConfig()]?.ttPixelId || APP_CONFIG['default'].ttPixelId
}

export const getPathLang = () => {
    const app = getAppIdConfig();
    return APP_CONFIG[app]?.lang || APP_CONFIG['default'].lang || 'en'
}

export const getDomain = () => {
    if(process.env.NODE_ENV === 'dev'){
        return 'zimonovel';
    }
    if(process.env.VUE_APP_ENV === 'test'){
        return 'zimonovel';
    }

    let host = location.host && location.host.split('.'); 
    
    return host.length < 2 ? "" : host[host.length -2];
}

export const getAppID = ()=>{
    return getDomain();
}

export const getAppIdConfig = () => {
    const appId = getAppID();
    // if(appId === 'loverflix' && getParam('adf')){
    //     return 'loverflix_' + getParam('adf'); 
    // }
    return appId;
}


export const getShowNewPay = () => {
    const appId = getAppIdConfig();
    return ['novellettes'].includes(appId);
}

export const getShowPaykka = () => {
    const appId = getAppIdConfig();
    return appId.includes('durianovel')
}

export const setCookieFbc = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    if (fbclid) {
        const fbc = `fb.1.${Date.now()}.${fbclid}`;
        document.cookie = `_fbc=${encodeURIComponent(fbc)}; max-age=7776000; path=/; SameSite=Lax`;
    }
}

export const setCookieAdId = () => {
    const adId = getParam('af_ad_id') || getParam('utm_content')
    if (adId) {
        Cookies.set(AD_ID_COOKIES_KEY, adId, { expires: 365, path: '/' });
    }
}

export const APP_CONFIG = {
    lovernovel: {
        fbPixleId: '2872547796247341',
        name: 'Lovernovel',
        email: 'lovernovel_service@novellettes.com',
        company: 'lovernovel.com',
        lang: 'en',
        service: `
            <h1>Use of terms</h1>
            <section>
                <h2>Welcome to Lovernovel!</h2>
                <p>This Lovernovel service agreement (Hereinafter referred to as "Agreement") is entered into by and between Clockwise International (HongKong) Limited (Address: FLAT/RM A 12/F ZJ 300, 300 LOCKHART ROAD, WAN CHAI,HONG KONG). (Hereinafter referred to as "PR") and Lovernovel's users (Hereinafter referred to as "Users"), concerning the installation, usage and related matters of "Lovernovel" application (Hereinafter referred to as "Lovernovel"). By clicking "I agree" or other ways to accept the Agreement, you acknowledge that you have reached an agreement with Lovernovel and accept all the following terms and conditions.</p>
            </section>
            <section>
                <h2>Article 1 Users' Service</h2>
                <p>Users must (i) read through and accept this Agreement before installing, copying, downloading, visiting or any other ways to use Lovernovel, (ii) download Lovernovel from websites or media appointed by PR. PR has no obligations or liabilities on any possible risks and/or losses caused by Users' breach of this Agreement.</p>
            </section>
            <section>
                <h2>Article 2 Intellectual Property</h2>
                <p>2.1 PR is the copyright owner of Lovernovel. All of the Lovernovel's intellectual property rights, as well as information content related to Lovernovel, including but not limited to text representations and combinations thereof, icons, graphic decorations, images, charts, colors, interface designs, layout frameworks, relevant data, additional programs, printed materials or electronic documents, etc., are protected under copyright laws and international copyright treaties as well as other intellectual property laws and regulations. Users shall not reverse engineer, decompile, or disassemble Lovernovel without the prior written approval of PR.</p>
                <p>2.2 Users acknowledge that any texts, images, graphic materials of the network service provided by PR are protected under copyright, trademark and/or other property ownership laws. Without the prior written approval of PR, foregoing information shall not be (i) directly or indirectly published or played in any media, (ii) rewrote or republished for the purpose of publication or playing, or (iii) used for any other commercial purposes. All or any parts of the information shall be only available for private and non-commercial purpose to be saved in Users' terminals. PR has no obligations or liabilities to any Users or third parties on any damages and/or losses caused by the delay, inaccuracies, errors, omissions (i) of the information, (ii) during the transmission or submission of the information or any parts hereof.</p>
            </section>
            <section>
                <h2>Article 3 Payment</h2>
                <p>3.1 Lovernovel is a free application available to be unlimitedly download, copy, install and use for non-commercial purpose.</p>
                <p>3.2 Internet fee may caused and charged by the mobile operator during the downloading and using of Lovernovel. Users shall consult local mobile operator for details.</p>
                <p>3.3 Lovernovel provides books authorized by the copyright owners. Users may be charged while reading some books or contents thereby. Lovernovel shall give Users a specific prompt before the charge. Users press "Cancel" or "Back" to cancel, and PR does not charge any fees.</p>
                <p>3.4 Lovernovel accepts payments including but not limited to Google wallet, etc. Users are deemed to accept Lovernovel's payment methods by accepting this Agreement.</p>
            </section>
            <section>
                <h2>Article 4 Users' Obligations</h2>
                <p>4.1 Users represent and warrant to use Lovernovel (i) legitimately and honestly, (ii) without infringing any third party's legitimate rights and interests.</p>
                <p>4.2 Users represent and warrant not to spitefully delete, change, add functions or data saved in the application, or designedly avoid or destroy technical measures of PR for the protection of Lovernovel's copyright. Users shall take all risks and responsibilities caused by their breach of this term. In case Users involve Lovernovel into any illegal activities or breach the purpose of this Agreement, PR has the right to stop providing services to Users immediately and reserve the right to investigate and affix the responsibilities of Users through judicial channels.</p>
                <p>4.3 Users represent and warrant not to (i) imitate PR's products and services for commercial purposes, (ii) copy or imitate PR's design philosophy, interface, functions and charts, or (iii) modify or create other derivative products of Lovernovel without the prior written approval of PR.</p>
                <p>4.4 Users shall not use Lovernovel or its services to make, upload, copy, send, share contents that violates applicable laws.</p>
                <p>4.5 Users shall take all responsibilities for compensation to PR and/or others' losses caused by their breach of this Agreement. Should PR take such responsibilities, Users shall compensate for PR's related costs and losses, including reasonable attorney's fees.</p>
                <p>4.6 Users acknowledge that breach of any of the above representations and warranties or PR's rules and/or notices may result in immediate termination of their use of Lovernovel without any refund or prior notice.</p>
                <p>4.7 Users agree to accept all information services provided by PR while using Lovernovel.</p>
            </section>
            <section>
                <h2>Article 5 Rights and Obligations</h2>
                <p>5.1 PR has the right to modify and update Lovernovel at any time based on the needs of operation and network environment.</p>
                <p>5.2 In case Users breach this Agreement while using Lovernovel and cause losses to PR, PR has the right to take measures, including but not limited to stop license and services, restrict for use, investigate and affix legal liability, etc.</p>
                <p>5.3 PR may, in its sole discretion, discontinue provision of Lovernovel at any time without liability and/or notice to Users.</p>
            </section>
            <section>
                <h2>Article 6 Disclaimer and Liability Limitations</h2>
                <p>Users acknowledge that PR shall not be liable for the following conditions, including but not limited to:</p>
                <p>6.1 System problems caused by hurricane, earthquakes, tsunami, flood, electrical outages, war, terrorist attack, etc. ("Event of Force Majeure").</p>
                <p>6.2 Service problems caused by hacker attack, telecom department technical adjustments or failures, website update, bank problems, etc.</p>
                <p>6.3 PR does not warrant that (i) Lovernovel has no technical bugs, (ii) PR fixes all bugs of Lovernovel, (iii) Lovernovel meets all needs of Users.</p>
                <p>6.4 The only solution of dissatisfaction with this Agreement or Lovernovel is to stop using Lovernovel.</p>
                <p>6.5 Users agree that this Agreement shall be governed by and any dispute arising out of or in connection with this Agreement shall be negotiated between PR and Users in good faith. If, however, the dispute cannot be resolved, both parties agree to submit to the district Court where PR located at for arbitration.</p>
                <p>6.6 Any term of this Agreement, for whatever reason, completely or partially invalid or unenforceable or in violation of any applicable laws, shall be deemed to be deleted. Other terms of this agreement shall remain valid and have binding force.</p>
            </section>
            <section>
                <h2>Article 7 Auto-Renewal Service Rules</h2>
                <p>By subscribing to, opening and using the Lovernovel membership auto-renewal service (hereinafter collectively referred to as "Auto-Renewal Service"), you agree to these rules.</p>
                <p>You understand and agree that:</p>
                <p>7.1 If you open this Auto-Renewal Service and do not explicitly cancel this Auto-Renewal Service during the Subscription Period, the relevant entity will automatically deduct the balance from your own top-up account, bound third-party payment account, bank card, communication account, etc. (hereinafter collectively referred to as "Accounts") at the time of 1 day before the expiration of each Subscription Period. The service fee for the next subscription period will be automatically deducted from the balance of your Accounts, so as to extend the validity period of the corresponding subscription period. You should pay attention to the status of the above-mentioned accounts and debitable balances, and you will bear the risk and/or loss due to account problems or insufficient balance resulting in renewal failure.</p>
                <p>7.2 Subscription period: one week, one year, etc. (subject to the description on the subscription page), members can choose by themselves.</p>
                <p>7.3 Lovernovel can offer a free trial to new subscribers of paid services. If you purchase a paid service subscription that includes a free trial, you will be able to use the paid service for free during the free trial period. At the end of the applicable free trial period, you will be charged the subscription fee and will continue to be billed until you cancel your subscription. In order to avoid incurring any charges, you must cancel before the end of the free trial period.</p>
                <p>7.4 You acknowledge and agree that Lovernovel has the right to adjust the price of the service. If Lovernovel intends to adjust the price of the service after you activated the auto-renewal service, Lovernovel will notify you in advance by appropriate means (including but not limited to onsite announcements, SMS, etc.). If you do not agree to the service price adjustment, you may cancel this auto-renewal service in accordance with these rules. If you do not cancel this auto-renewal service, the subsequent service fees deducted by the relevant entity will be based on the adjusted service fees. If you cancel within 24 hours before the expiration of the subscription period, the relevant entity may stop deducting the service fees for the next subscription period according to the adjusted service fees. After the cancellation of this auto-renewal service, if you open the auto-renewal service again, the service fee automatically deducted by the relevant entity shall be based on the service fee displayed on the page at that time.</p>
                <p>7.5 The unsubscribe method for auto-renewal users is as follows.</p>
                <p>If you have purchased a paid service subscription for auto-renewal, you can cancel the subscription at any time before the end of the current billing period, and the cancellation will take effect in the next billing period. You will retain access to the paid service from the date of cancellation until the start of the next billing period.</p>
                <p>Apple IAP (in-app purchase) payment: Open "Settings" of your iOS device --> go to "iTunes Store and App Store" --> click "Apple ID", select "View Apple ID", enter the "Account Settings" page, click "Subscription", and select Lovernovel membership to cancel the subscription. If you do not cancel the auto-renewal feature 1 day before the subscription period expires, the subscription will be automatically renewed and debited. Google Play Store: Go to google play --> click "Settings" --> click "Subscriptions", and select Lovernovel membership to cancel your subscription. If you do not cancel the auto-renewal function 1 day before the subscription period expires, the subscription will be renewed and debited automatically.</p>
                <p>7.6 Lovernovel may also stop providing auto-renewal service to you according to its operation strategy, and your Lovernovel membership will be terminated from the date of expiration of the current service period.</p>
            </section>
            <section>
                <h2>Article 8 Content Related</h2>
                <p>To ensure that Lovernovel remains a safe and civilized platform, we have developed a set of standards to define content that is harmful or inappropriate to users and prohibit such content from appearing on our platform.</p>
                <p>CSAM/CSEM: If a book contains child abuse content, we will immediately remove it from Lovernovel. This includes all child sexual abuse content.</p>
                <p>Rape: We do not allow any books to contain forced sexual content or forced bullying.</p>
                <p>Incest: We do not allow any books to contain content that undermines human ethics and social norms. Inappropriate sexual relationships between relatives.</p>
                <p>Bestiality: We do not allow any books to contain sexual acts between humans and wild animals.</p>
                <p>For such issues, we will conduct uninterrupted content checks. Once discovered, we will immediately remove the content and permanently ban the author of the book from publishing its content on the platform. If you have any questions about the books we provide, please contact us: lovernovel_service@novellettes.com.</p>
                <h2>This Agreement shall be governed by the laws of the Hong Kong Special Administrative Region of the People's Republic of China.</h2>  
            </section>

        `
    },
    crabnovel: {
        fbPixleId: '1081737203961773',
        company: 'crabnovel.com',
        name: 'Crab Novel',
        email: 'ops@novellettes.com',
        companyName: 'Solas Limited',
        serviceP1: `This Crab Novel service agreement (Hereinafter referred to as "Agreement") is entered into by and between Solas Limited(Address: UNIT 89,3/F YAU LEE CTR NO 45 HOI YUEN RD KWUN TONG HONG KONG). (Hereinafter referred to as "PR") and Crab Novel users (Hereinafter referred to as "Users"), concerning the installation, usage and related matters of "Crab Novel" application (Hereinafter referred to as "Crab Novel"). By clicking "I agree" or other ways to accept the Agreement, you acknowledge that you have reached an agreement with Crab Novel and accept all the following terms and conditions.`,
    },
    zimonovel: {
        fbPixleId: '1380939299799054',
        company: 'zimonovel.com',
        name: 'Zimonovel',
        email: 'ops@novellettes.com',
        companyName: 'Clockwise International (HongKong) Limited',
    },
    deernovel:{
        fbPixleId: '2333357217110532',
        company: 'deernovel.com',
        name: 'Deernovel',
        email: 'service@novellettes.com',
        serviceP1: `This Deer novel service agreement (Hereinafter referred to as "Agreement") is entered into by and between novelqglobal.com (Hereinafter referred to as "PR") and Deer novel's users (Hereinafter referred to as "Users"), concerning the installation, usage and related matters of "Deer novel" application (Hereinafter referred to as "Deer novel"). By clicking "I agree" or other ways to accept the Agreement, you acknowledge that you have reached an agreement with Deer novel and accept all the following terms and conditions.`,
        lang: 'de',
    },
    lambnovel: {
        fbPixleId: '1081737203961773',
        company: 'lambnovel.com',
        name: 'Lambnovel',
        email: 'ops@novellettes.com',
        companyName: 'Kynix Group Limited'
    },
    ponynovel:{
        fbPixleId: '1081737203961773',
        company: 'ponynovel.com',
        name: 'Pony Novel',
        email: 'ops@novellettes.com',
        companyName: 'TerraFlow Limited',
        address: 'Aegis Chambers, 1st Floor, Ellen Skelton Building, 3076 Sir Francis Drake\'s Highway, Road Town, Tortola, VG1110, British Virgin Islands.'
    },
    polarnovel: {
        fbPixleId: '1081737203961773',
        company: 'polarnovel.com',
        name: 'Polar Novel',
        email: 'ops@novellettes.com',
        companyName: 'Kynix Group Limited'
    },
    default: {
        fbPixleId: '1081737203961773',
        ttPixelId: 'D1NMVABC77U5LQ9964K0',
        moneySymbol: '$',
        lang: 'en',
        company: 'zimonovel.com',
        name: 'Zimonovel',
        email: 'ops@novellettes.com',
        companyName: 'Clockwise International (HongKong) Limited',
        address: 'RM 10D R1, 10/F KIN GA IND BLDG 9 SAN ON ST TUEN MUN HONG KONG',
        // 支付是否需要登陆后支付
        payIslogin: false,
        serviceP1: null
    }
}

export const getAppInfo = () => {
    const appId = getAppIdConfig()
    const obj = {
        name: APP_CONFIG[appId]?.name || APP_CONFIG['default'].name,
        company: APP_CONFIG[appId]?.company || APP_CONFIG['default'].company,
        fbPixleId: APP_CONFIG[appId]?.fbPixleId || APP_CONFIG['default'].fbPixleId,
        ttPixelId: APP_CONFIG[appId]?.ttPixelId || APP_CONFIG['default'].ttPixelId,
        email: APP_CONFIG[appId]?.email || APP_CONFIG['default'].email,
        payIslogin: APP_CONFIG[appId]?.payIslogin || APP_CONFIG['default'].payIslogin,
        privacy: APP_CONFIG[appId]?.privacy || null,
        service: APP_CONFIG[appId]?.service || null,
        companyName: APP_CONFIG[appId]?.companyName || APP_CONFIG['default'].companyName,
        address: APP_CONFIG[appId]?.address || APP_CONFIG['default'].address,
        serviceP1: APP_CONFIG[appId]?.serviceP1 || APP_CONFIG['default'].serviceP1,
    }
    return obj
}

// cookie 设置用户
export const setUserInfo = (id, token) => {
    let expires = 365
    if(getAppIdConfig() === 'loverflix'){
        expires = 90
    }
    Cookies.set(USER_ID_COOKIES_KEY, id, { expires: expires })
    Cookies.set(USER_TOKEN_COOKIES_KEY, token, { expires: expires })
    
}

export const isApplePayApp = () => {
    // const app = ['loverflix'];
    // return app.includes(getAppID());
    return true
}

// 是否是投放用户
export const isToufang = () => {
    return getParam('ch')
}

export const isTtChannel = () => {
    return !!getParam('ttclid')
}

export function setToufang() {
    if(!getParam('ch')){
        if(isToufangWebView()){
           const location = window.location
            let search = ''
            if(location.search){
                search = '&ch=1'
            }else{
                search = '?ch=1'
            }
            this.$router.push(`${location.pathname + location.search}${search}`)
        }

    }
}

